import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";
import { formatDateWithMinutes } from "@utils/utilsDate";
import { EnrollmentConfigState } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/types";
import { resolveExpirationKind } from "@pages/Contents/V2/Corporate/Catalog/Enrollment/config/enrollmentFieldsConfig";

interface EnrollGroupArgs {
  corporateId: string;
  groupId: string | number | undefined;
  groupType: "STATIC" | "DYNAMIC";
  loSelections: { id: number; type: string }[];
  enrollType: string;
  config?: EnrollmentConfigState;
}

const buildExpirationFields = (config?: EnrollmentConfigState) => {
  if (!config) return {};
  const isFixedDate = resolveExpirationKind(config) === "fixed-date";
  return {
    forcedExpiration: config.enableExpiration
      ? !!config.forcedExpiration
      : false,
    daysToComplete:
      config.enableExpiration && !isFixedDate ? config.daysToComplete : null,
    expirationDate:
      config.enableExpiration && isFixedDate && config.expirationDate
        ? formatDateWithMinutes(new Date(config.expirationDate)).split(" ")[0]
        : null,
    isExpirationFixed: config.enableExpiration ? isFixedDate : null,
    isExpirationHard: config.enableExpiration
      ? config.expirationType === "hard"
      : false,
    attributesIds: config.attributesIds ?? [],
  };
};

export const enrollGroupToLearningObjects = async ({
  corporateId,
  groupId,
  groupType,
  loSelections,
  enrollType,
  config,
}: EnrollGroupArgs): Promise<void> => {
  if (!groupId || !enrollType || loSelections.length === 0) return;
  const body = {
    isAdmin: true,
    enrollDate: formatDateWithMinutes(new Date()),
    enrollType,
    groupType,
    domainId: null,
    learningObject: {
      corporateId: Number(corporateId),
      forcedEnroll: true,
      objectId: loSelections.map((s) => s.id),
    },
    massiveListDomainId: null,
    massiveListGroupId: [Number(groupId)],
    ...buildExpirationFields(config),
  };
  await fetcher(ServicesURL.postGroupEnrollmentMassive, MethodType.POST, body);
};
